import { InjectionToken } from '@angular/core';

export interface IConfigurationVM {
  readonly baseApiUrl: string;
  readonly encryptionKey: string;
 // readonly mapApiKey: string;
 // readonly placesApiKey: string;
 // readonly drugsEndpoints: string;
 // readonly payPalClientId: string;
}

export const CORE_CONFIGURATION = new InjectionToken<IConfigurationVM>(
  'core.config'
);
